import {LogLevel} from '@azure/msal-browser';

export const environment = {
  production: false,
  staging: true,
  development: false,
  hmr: false,
  azureClientID: '7edca6b8-ec29-4f44-b823-1868c0a5cc90',
  apiURL: 'https://rest-staging.torchbi.com/api',
  filesAPIURL: 'https://files.torchbi.com/api',
  redirectUri: 'https://staging.torchbi.com/authenticated',
  postLogoutRedirectUri: 'https://staging.torchbi.com/login',
  tinyAPIKey: 'xm4kkkgj1aoyy4rmh2ljje3cl3ypebfexfyza1vqzmsjg4tc',
  torchAPIKey: 'BXDP2AJ-AZ7M9GB-MRFF2V1-0GDSX85',
  filesWS: 'https://files.torchbi.com',
  appInsights: {
    instrumentationKey: '899a9b90-3237-4a5c-801b-c526f9ac8e94'
  },
  enableServiceWorker: true,
  pwaName: 'TORCH - Staging',
  emitLogs: true,
  msal: {
    logLevel: LogLevel.Error,
    piiLogging: true,
  },
  maxDiscrepancyQueryExport: 10000,
  maxRemovalQueryExport: 10000,
  maxWeightBalanceQueryExport: 40000,
};
